const signInFields = [
  {
    id: "email",
    name: "email",
    type: "email",
    placeholder: "email",
    // label: "Email",
    required: true,
  },
  {
    id: "password",
    name: "password",
    type: "password",
    placeholder: "password",
    // label: "Password",
    required: true,
  },
];

export { signInFields };
